export const LANDING_PAGE_URL =
  process.env.REACT_APP_API_BASE_URL_LANDING_PAGE;

export const IMAGE_URL = process.env.REACT_APP_API_BASE_URL_IMAGE;